import { SyncManager } from '@/firebase/SyncManager'
import useModal from '@/hooks/useModal'
import ModalCustom from '@/scenes/Editor/components/Modal/Modal'
import { ShowModalType } from '@/scenes/engine/common/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'

function ModalDeleteProject() {
    const { showModalType, setShowModalType } = useModal()
    const { t } = useTranslation()
    const history = useHistory()
    const location = useLocation()
  return (
    <ModalCustom
      isOpen={showModalType === ShowModalType.DELETE_PROJECT}
      onClose={() => setShowModalType(null)}
      content={{
        header: t('Delete project'),
        desc: t("It cannot be undone."),
      }}
      action={{
        primary: {
          name: t('Delete'),
          handle: () => {
            SyncManager.shared.deleteProjects(SyncManager.shared.idDeleteProject)
            setShowModalType(null)
            !location.pathname.includes('create') && history.push('/create')
          },
        },
        secondary: {
          name: t('Cancel'),
          handle: () => {
            SyncManager.shared.idDeleteProject = null
            setShowModalType(null)
          },
        },
      }}
    />
  )
}

export default ModalDeleteProject